import script from "./TradesFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TradesFilter.vue?vue&type=script&setup=true&lang=js"

import "./TradesFilter.vue?vue&type=style&index=0&id=6d27dbde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d27dbde"]])

export default __exports__